<div class="factoid">
    @if (title) {
        <h3
            class="factoid__title"
        >
            {{ title }}
        </h3>
    }

    @if (data) {
        <div class="factoid__data">
            @for (line of data; track $index) {
                <div
                    class="factoid__data-line"
                >
                    {{ line }}
                </div>
            }
        </div>
    }
</div>
